import Swiper from 'swiper'

export default (element) => {

  const initSwiper = () => {
    const imagesSliders = element.querySelectorAll('.events-images-swiper');
    const quotesSliders = element.querySelectorAll('.events-quotes-swiper');
    imagesSliders.forEach(slider => {
      // eslint-disable-next-line no-unused-vars
      const swiper = new Swiper(slider, {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 1,
            spaceBetween: 0,
          }
        },
        spaceBetween: 10,
        slidesPerView: 1.1,
      });
    })
    quotesSliders.forEach(slider => {
      // eslint-disable-next-line no-unused-vars
      const swiper = new Swiper(slider, {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        slidesPerView: 1,
      });
    })
  };

  const initTabs = () => {
    const buttons = element.querySelectorAll('[data-target="Tab"]')
    buttons.forEach(btn => btn.addEventListener('click', () => {
      hideTabs()
      btn.classList.add('active')
      const tab = element.querySelector(`[data-id="${btn.dataset.targetId}"]`)
      tab.classList.add('active')
    }))
  }

  const hideTabs = () => {
    const buttons = element.querySelectorAll('[data-target="Tab"]')
    buttons.forEach(btn => {
      const tab = element.querySelector(`[data-id="${btn.dataset.targetId}"]`)
      btn.classList.remove('active')
      tab.classList.remove('active')
    })
  }

  const init = () => {
    initSwiper()
    initTabs()
  }

  init()
}